import { Dispatch} from "react";
import { IADPState, NetworkConnectionState, NetworkConnectionStateObj, actions } from "../state";
import {IADPActions, IADPHeaderActions } from "../state/Actions";
import RequestService from "../util/request";
import { environment } from "../util";
import { postMessageToAdpBridge } from "./useIPCBridge";
import { AppStateProvider } from "../state/Provider";
import { NetworkConnectionType } from "@npd-ng/adp-types";
import { useDeviceValidationService } from "./useDeviceValidationService";
import { useAppState } from "./useAppState";
const logPrefix = "[ADPClient][NetworkServiceHook]"

function checkNetworkState(){
  const provider = AppStateProvider.getInstance();
  const state = provider.getState();
 const networkConnectionState = state.sessionState.networkConnectionState;
 const selectedAssessmentMode = state.sessionState.selectedAssessmentMode;
  if(networkConnectionState==="offline"){
    if(selectedAssessmentMode=== "online"){
      return "NoInternetConnectionDetected";
    }
    else if(selectedAssessmentMode=== "ncs"){
     return "NoRouterConnectionDetected";
    }
  }
  else if (networkConnectionState==="online" && selectedAssessmentMode=== "ncs"){
    return "NoRouterConnectionDetected";

  }
  else if (networkConnectionState==="router" && selectedAssessmentMode=== "online"){
   return "NoInternetConnectionDetected";
  }
  return undefined;

}
const networkStressTestInProgress=()=>{
  const provider = AppStateProvider.getInstance();
  const state = provider.getState();
  return state.networkReadinessState.executionState.state === "InProgress";
}
export function useNetworkService(dispatchToApp: Dispatch<IADPActions>,dispatch?: Dispatch<IADPHeaderActions>) {
   const {isDeviceConnectedToNAEPRouter,isDeviceOnlineWithAccessToNAEPCloud}  = useResolveServiceStatus(dispatchToApp);
    function initElectronNetworkResolution(){
          console.log("[ADPClient] initElectronNetworkResolution");
            const onNetworkStateChange = (event: any)=>{
              const provider = AppStateProvider.getInstance();
              const state = provider.getState();
            console.log("onNetworkStateChange",event.detail.message[0]);
            if(dispatch)dispatch(actions.createSetNetworkAction(event.detail.message[0].connectionType as NetworkConnectionState));
            dispatchToApp(actions.createSetNetworkAction(event.detail.message[0].connectionType as NetworkConnectionState));
            dispatchToApp(actions.createSetNetworkDetails(event.detail.message[0] as NetworkConnectionStateObj));
            if(state.sessionState.selectedAssessmentMode=== "notselected" || networkStressTestInProgress()) return;
            dispatchToApp(actions.createWarningAction(state.sessionState.selectedAssessmentMode === "ncs" ? "NoRouterConnectionDetected" : "NoInternetConnectionDetected"));
            };
            window.addEventListener('network-state-changed', onNetworkStateChange);
            window.addEventListener('network-state-changed-init', async (event)=>{ //@ts-ignore
              console.log("network-state-changed event",event.detail); //@ts-ignore
             if(dispatch)dispatch(actions.createSetNetworkAction(event.detail)); //@ts-ignore
              dispatchToApp(actions.createSetNetworkAction(event.detail)); 
            },{once:true});
            return;
        };  
   async function initWebAPINetworkResolution(){
    const provider = AppStateProvider.getInstance();
    const state = provider.getState();
      console.log("[ADPClient] initWebAPINetworkResolution");
       let  networkState:NetworkConnectionState = window.navigator.onLine ? "online" : "offline"; 
      const validateIP = async ()=>{
        const networkDetails=()=>{
          const promise =  new Promise<{macAddress: string, ipv4:string,ipv6:string} | NetworkConnectionType>((resolve, reject) => {
              const handler =(event: any)=>{
                resolve(event.detail?.data);
                dispatchToApp(actions.createSetNetworkDetails(event.detail?.data as NetworkConnectionStateObj));
                  window.removeEventListener('NetworkDetailsEvent',handler);
              }
                window.addEventListener('NetworkDetailsEvent', handler);
            });
          
            return promise;
        }
        postMessageToAdpBridge({type:"NetworkDetails"}); 
        const responseFromEx = await networkDetails();
        const isRouterConnection = isDeviceConnectedToNAEPRouter(typeof responseFromEx === "string" ? responseFromEx : responseFromEx?.ipv4);
        let connectionType:NetworkConnectionState = isRouterConnection ? "router" : window.navigator.onLine ? "online" : "offline";
        if(connectionType=== "online"){
          if(!await isDeviceOnlineWithAccessToNAEPCloud())
          connectionType = "router"
        }
        return connectionType;
      }
    
      if(window.navigator.onLine){
        if(state.appState.runtimePlatform.platform === "ChromeWithExtension"){
          networkState =  await validateIP();
        }
        else {
          if(networkState=== "online"){
            if(!await isDeviceOnlineWithAccessToNAEPCloud())
            networkState = "router"
          }
         
        }
      
      }
  
      if(dispatch)dispatch(actions.createSetNetworkAction(networkState));
      dispatchToApp(actions.createSetNetworkAction(networkState));
      //listen on network changes
      window.addEventListener("offline", (e) => {
        const provider = AppStateProvider.getInstance();
        const state = provider.getState();
        console.log(logPrefix,"device is offline");
        //TODO - combine into one action
        if(dispatch)dispatch(actions.createSetNetworkAction("offline"));
        dispatchToApp(actions.createSetNetworkAction("offline"));
        if(state.sessionState.selectedAssessmentMode=== "notselected" || networkStressTestInProgress()) return;
        dispatchToApp(actions.createWarningAction(state.sessionState.selectedAssessmentMode === "ncs" ? "NoRouterConnectionDetected" : "NoInternetConnectionDetected"));
      
      });
      window.addEventListener("online", async (e) => {
        const provider = AppStateProvider.getInstance();
        const state = provider.getState();
        console.log(logPrefix,"device is online");
       let connectionType = "online" as NetworkConnectionState;
       if(state.appState.runtimePlatform.platform === "ChromeWithExtension"){
         connectionType =  await validateIP();
       } 
       else {
          if(!await isDeviceOnlineWithAccessToNAEPCloud())connectionType = "router"
       }
        if(dispatch)dispatch(actions.createSetNetworkAction(connectionType));
        dispatchToApp(actions.createSetNetworkAction(connectionType));
      });
      //network change monitoring
      setInterval(async ()=>{
        const provider = AppStateProvider.getInstance();
        const state = provider.getState();
        if(navigator.onLine){
          let connectionType = "online" as NetworkConnectionState;
          if(state.appState.runtimePlatform.platform === "ChromeWithExtension"){
            connectionType =  await validateIP();
          } 
          else {
             if(!await isDeviceOnlineWithAccessToNAEPCloud())connectionType = "router"
          }
          if(state.sessionState.networkConnectionState === connectionType)return;
          if(dispatch)dispatch(actions.createSetNetworkAction(connectionType));
          dispatchToApp(actions.createSetNetworkAction(connectionType));
        }
      },20000);
      window.addEventListener('network-state-changed', async (event)=>{ //@ts-ignore
        let connectionType = event.detail as NetworkConnectionState;
        console.log("network-state-changed event",connectionType); //@ts-ignore
        if(connectionType=== "online"){
          if(!await isDeviceOnlineWithAccessToNAEPCloud())
          connectionType = "router"
        }
       if(dispatch)dispatch(actions.createSetNetworkAction(connectionType)); //@ts-ignore
        dispatchToApp(actions.createSetNetworkAction(connectionType)); 
      },{once:true});
      return;
   }     
 function initNetworkResolution(){
 if(navigator.userAgent.includes("Electron")){
  initElectronNetworkResolution()
}
else  {
  initWebAPINetworkResolution();
}

 }

return  {initNetworkResolution,initElectronNetworkResolution,initWebAPINetworkResolution};
};

export function useResolveServiceStatus(dispatch: Dispatch<IADPActions>) {
  const {state} = useAppState()
   const {performEnvDeviceValidation} = useDeviceValidationService(dispatch,state);
  async function isDeviceOnlineWithAccessToNAEPCloud ():Promise<boolean>{
    return new Promise(async (resolve) => {
      if(window.navigator.onLine){
        console.log("[ADpClient][useNetworkService] Device is online, check if online NAEP services are reachable");
        const onlineURL =`${environment.resolveApiDomain()}/session-service/health`;
        RequestService.checkServerStatus(onlineURL,5000).then((response:any)=>{
          if(response?.data?.status==="ok"){
            console.log("Device is online and NAEP services are reachable");
            resolve(true);
          }
        else {
          resolve(false);
        }
        }).catch((e)=>{
          console.warn("Device is online , however,  Online NAEP services are not reachable",e);
          resolve(false)
        })
      }
      else {
        resolve(false)
      }
    });
  }
     
 async function checkOnlineServerAvailability ():Promise<boolean>{
   return new Promise(async (resolve) => {
     const provider = AppStateProvider.getInstance();
     const state = provider.getState();
     const config  = state?.appState.configuration;
     if(state.sessionState.networkConnectionState === "online"){
       console.log("[ADpClient][useNetworkService] Device is online, check if online NAEP services are reachable");
       const onlineURL =`${environment.resolveApiDomain()}/${config?.onlineServices?.cloudServiceHealth}`;
       RequestService.checkServerStatus(onlineURL,15000).then(()=>{
         console.log("Device is online and NAEP services are reachable");
         resolve(true);
       }).catch((e)=>{
         console.warn("Device is online , however,  Online NAEP services are not reachable",e);
         if(dispatch) dispatch(actions.createWarningAction("NoServerConnectionDetected"));
         resolve(false)
       })
     }
     else {
      if(dispatch) dispatch(actions.createWarningAction("NoInternetConnectionDetected"));
       resolve(false)
     }
   });
 } ;
 async function checkNCSServerAvailability ():Promise<boolean>{
   return new Promise(async (resolve) => {
    const provider = AppStateProvider.getInstance();
    const state = provider.getState();
    const config  = state?.appState.configuration;
     if(state.sessionState.networkConnectionState === "router"){
       console.log("[ADpClient][useNetworkService] Device is online, check if NAEP classroom services are reachable");
       const ncsHealth =`https://${config?.ncsServices?.defaultDomain}:${config?.ncsServices.port}${config?.ncsServices.ncsHealth}`;
       RequestService.checkServerStatus(ncsHealth,15000).then(async (response:any)=>{
         console.log("Device is online and NAEP Classrroom services are reachable");
         const ncsConfig: IADPState["connectedNCSState"] = response?.data?.data;
         if(dispatch) dispatch(actions.createUpdateNCSConfigAction(ncsConfig));
         const checkResult  = await performEnvDeviceValidation(response?.data?.data.environment);
         resolve(checkResult);
       }).catch((e)=>{
         console.warn("Device is online , however, NAEP Classrroom services are not reachable",e);
         if(dispatch) dispatch(actions.createWarningAction("NoNCSConnectionDetected"));
         resolve(false);
       });
     }
     else {
       resolve(false);
       if(dispatch) dispatch(actions.createWarningAction("NoRouterConnectionDetected"));
     }
   });
 } 

 function isDeviceConnectedToNAEPRouter(ipAddress:string | undefined){
  if(ipAddress && ipAddress.indexOf("192.168.15") > -1){
    return true
  }
  return false;
 }
 

return {checkOnlineServerAvailability,checkNCSeServerAvailability: checkNCSServerAvailability,isDeviceOnlineWithAccessToNAEPCloud,isDeviceConnectedToNAEPRouter}
};

export {checkNetworkState}

